import React, { PureComponent } from 'react'
import { withTranslation } from 'react-i18next'
import Loader from '../../Shared/Loader'
import PropTypes from 'prop-types'
import { getDashboardToken } from '../../../api'
import Alert from '../../Shared/Alert'
import './style.scss'
import activityTrackingService from '../../../services/activityTrackingService'
import Dashboard from '../Property/Dashboard'
import { authenticate, getItem, setToken } from '../../../http/driveApiGateway/client'
import SalesChannels from '../Property/SalesChannels'
import TourOperators from '../Property/TourOperators'
import Compare from '../Property/Compare'

class DashboardWidget extends PureComponent {

  abortController = new AbortController()

  state = {
    initialized: false,
    error: null,
    loading: false,
    foundItem: null,
    relatedItems: null
  }

  componentDidMount () {
    this.init(true)
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (
      prevProps.permissions !== this.props.permissions ||
      prevProps.giataId !== this.props.giataId ||
      prevProps.widget !== this.props.widget) {
      this.init(false)
    }
  }

  componentWillUnmount () {
    if (this.abortController) {
      this.abortController.abort()
    }
  }

  init (initial) {
    try {
      if (!initial) {
        this.abortController.abort()
        this.abortController = new AbortController()
      }
      this.setState({ initialized: false, loading: true, error: null }, async () => {
        if (!this.hasPermission()) {
          console.log('no permission for this module')
          this.setState({ loading: false, error: 'No permission for this module' })
          return
        }
        if (this.props.trackPageViewName) {
          activityTrackingService.trackPageView(this.props.trackPageViewName, {
            giataId: this.props.giataId,
          })
        }
        try {
          const response = await getDashboardToken(this.props.giataId, this.abortController).fetchPromise
          const responseAuthenticate = await authenticate(response.token).fetchPromise
          setToken(responseAuthenticate.token)
          const itemResponse = await getItem(null, this.props.giataId).fetchPromise
          const foundItem = itemResponse.items[0] ?? null
          if (!foundItem) {
            // noinspection ExceptionCaughtLocallyJS
            throw new Error('Failed to get hotel item')
          }
          if (!itemResponse.hasOwnProperty('related')) {
            // noinspection ExceptionCaughtLocallyJS
            throw new Error('Failed to related items')
          }
          this.setState({ initialized: true, loading: false, foundItem, relatedItems: itemResponse.related })
        } catch (e) {
          console.error(e)
          if (this.abortController.signal.aborted) {
            return
          }
          this.setState({ error: 'Error', loading: false })
        }
      })
    } catch (e) {
      if (this.abortController.signal.aborted) {
        return
      }
      this.setState({ error: 'Error', loading: false })
    }
  }

  hasPermission () {
    if (
      !this.props.permissions || !this.props.permissions.dashboard
      || (
        this.props.widget === 'compare'
        && (!this.props.permissions.dashboard.distribution || !this.props.permissions.dashboard.tourOperators)
      )
      || (this.props.widget !== 'compare' && !this.props.permissions.dashboard[this.props.widget])
    ) {
      return false
    }
    return true
  }

  render () {
    if (this.state.loading) {
      return <div className={'page'}><Loader size={64}/></div>
    }
    if (this.state.error !== null) {
      return <div className={'page'}><Alert type={'danger'}>{this.state.error}</Alert></div>
    }
    if (this.state.initialized === false) {
      return null
    }
    if (this.props.widget === 'scores') {
      return <Dashboard permissions={this.props.permissions}
                        confirmedImagesCount={this.props.confirmedImagesCount}
                        giataId={this.props.giataId} item={this.state.foundItem}/>
    }
    if (this.props.widget === 'distribution') {
      return <SalesChannels
        giataId={this.props.giataId}
        item={this.state.foundItem}
        relatedItems={this.state.relatedItems}
        propertyImage={this.props.propertyImage}
      />
    }
    if (this.props.widget === 'tourOperators') {
      return <TourOperators
        giataId={this.props.giataId}
        item={this.state.foundItem}
        relatedItems={this.state.relatedItems}
        propertyImage={this.props.propertyImage}
      />
    }
    if (this.props.widget === 'compare') {
      return <Compare
        giataId={this.props.giataId}
        item={this.state.foundItem}
        relatedItems={this.state.relatedItems}
        propertyImage={this.props.propertyImage}
      />
    }
    return null
  }
}

DashboardWidget.propTypes = {
  permissions: PropTypes.object.isRequired,
  giataId: PropTypes.number.isRequired,
  widget: PropTypes.oneOf(['scores', 'distribution', 'tourOperators', 'compare']).isRequired,
  confirmedImagesCount: PropTypes.number,
  trackPageViewName: PropTypes.string,
  propertyImage: PropTypes.string,
}

export default withTranslation()(DashboardWidget)
